export const isOverlapping = (direction, arg1, arg2) => {

    const _positionInfo1 = arg1;
    const _positionInfo2 = arg2;

    const _arg1End = _positionInfo1[direction] + _positionInfo1[`${direction}s`];
    const _arg2End = _positionInfo2[direction] + _positionInfo2[`${direction}s`];

    if (_positionInfo2[direction] >= _positionInfo1[direction] && _positionInfo2[direction] < _arg1End) {
        return true;
    }

    if (_arg2End > _positionInfo1[direction] && _arg2End <= _arg1End) {
        return true;
    }

    return _positionInfo2[direction] < _positionInfo1[direction] && _arg2End > _arg1End;
    
}

export const isOverlappingRow = (row1, row2) => {

    return isOverlapping("Row", row1, row2) || isOverlapping("Row", row2, row1);
};

export const isOverlappingColumn = (column1, column2) => {

    return isOverlapping("Column", column1, column2) || isOverlapping("Column", column2, column1);
};

export const rowsSum = (row1, row2) => {

    const _row1End = row1.Row + row1.Rows;
    const _row2End = row2.Row + row2.Rows;

    const _diff = _row2End - _row1End;

    return _diff > 0 ? row1.Rows + _diff : row1.Rows;

};